import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { LayoutDashboard, FileText, Settings, LogOut, Plus } from 'lucide-react';

const DashboardLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const navItems = [
    { path: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/dashboard/create', icon: Plus, label: 'Create Profile', roles: ['admin', 'operator'] },
  ];

  return (
    <div className="flex h-screen bg-[#F8FAFC]" data-testid="dashboard-layout">
      <aside className="w-64 bg-white border-r border-[#E2E8F0] flex flex-col">
        <div className="p-6 border-b border-[#E2E8F0]">
          <h1 className="text-xl font-bold tracking-tight" style={{ fontFamily: 'Manrope, sans-serif' }}>
            eSIM Portal
          </h1>
          <p className="text-xs text-muted-foreground mt-1" style={{ fontFamily: 'Inter, sans-serif' }}>
            Profile Management
          </p>
        </div>

        <nav className="flex-1 p-4 space-y-1">
          {navItems.map((item) => {
            if (item.roles && !item.roles.includes(user?.role)) return null;
            const isActive = location.pathname === item.path;
            return (
              <Button
                key={item.path}
                variant={isActive ? 'default' : 'ghost'}
                className={`w-full justify-start ${
                  isActive ? 'bg-[#0F172A] text-white' : 'text-gray-700 hover:bg-[#F1F5F9]'
                }`}
                onClick={() => navigate(item.path)}
                data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
              >
                <item.icon className="mr-2 h-4 w-4" />
                {item.label}
              </Button>
            );
          })}
        </nav>

        <div className="p-4 border-t border-[#E2E8F0]">
          <div className="mb-3 p-3 bg-[#F8FAFC] rounded-md">
            <p className="text-xs font-medium" style={{ fontFamily: 'Inter, sans-serif' }}>
              {user?.full_name}
            </p>
            <p className="text-xs text-muted-foreground" style={{ fontFamily: 'Inter, sans-serif' }}>
              {user?.email}
            </p>
            <span className="inline-flex items-center mt-2 rounded-full bg-[#2563EB]/10 px-2 py-0.5 text-xs font-medium text-[#2563EB]">
              {user?.role}
            </span>
          </div>
          <Button
            variant="ghost"
            className="w-full justify-start text-red-600 hover:text-red-700 hover:bg-red-50"
            onClick={handleLogout}
            data-testid="logout-button"
          >
            <LogOut className="mr-2 h-4 w-4" />
            Sign Out
          </Button>
        </div>
      </aside>

      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
};

export default DashboardLayout;
